import { Types } from "../actions/actionTypes";
import initialState from "../store/initial-state";

export const userDataReducer = (state = initialState.userDataReducer, action) => {
    switch (action.type) {
        case Types.USER_ROLE: {
            let userRole = action.payload.userRole;
            return {
                ...state,
                userRole: userRole,
            }
        }
        default:
            return state
    }
}